/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useForeRecommendChartsQuery } from "services/api";

const HotBoard = () => {
  const { data: recommendCharts = [], isLoading } =
    useForeRecommendChartsQuery();

  const randomIndex = Math.floor(Math.random() * recommendCharts.length);

  if (isLoading) {
    return null;
  }

  const chart = recommendCharts[randomIndex];

  return (
    <div
      className="relative overflow-hidden pb-[60%]"
      css={css`
        & > * {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      `}
      dangerouslySetInnerHTML={{ __html: chart.htmlText }}
    />
  );
};

export default HotBoard;
